
//popup
document.addEventListener('DOMContentLoaded', () => {

  //次回から非表示に（閉じたとき）
  const checkFlag = () => {
    if (noShow.checked) {
      sessionStorage.setItem('hidePopup', 'off');
    }
  };

  //ローカルストレージから表示・非表示判定
  const hidePopup = sessionStorage.getItem('hidePopup');
  if (hidePopup == null) {

    if (hidePopup != "off") {
      //modal
      MicroModal.init();
      const homePopup = document.getElementById('homePopup');
      if (homePopup !== null) {
        MicroModal.show('homePopup', { disableScroll: true, disableFocus: true, awaitOpenAnimation: true, onClose: checkFlag });
      }
    }

    //次回から非表示に（遷移したとき）
    const noShow = document.getElementById('noShow');
    const link = document.querySelector('.modal__link');
    link.addEventListener('click', (e) => {
      if (noShow.checked) {
        e.preventDefault();
        sessionStorage.setItem('hidePopup', 'off');
        //console.log(link.getAttribute('href'));
        location.href = link.getAttribute('href');
      }
    });

  }
});
